"use strict";
exports.__esModule = true;
exports.formatId = void 0;
var ramda_1 = require("ramda");
var trim = function (str) { return (str === null || str === void 0 ? void 0 : str.replace(/^\s+|\s+$/g, '')) || ''; };
var ascii = function (str) {
    return str
        .replace(/[áàâä]/g, 'a')
        .replace(/[éèêë]/g, 'e')
        .replace(/[íìîï]/g, 'i')
        .replace(/[óòôö]/g, 'o')
        .replace(/[úùûü]/g, 'u')
        .replace(/ç/g, 'c')
        .replace(/ñ/g, 'n')
        .replace(/œ/g, 'oe')
        .replace(/æ/g, 'ae');
};
exports.formatId = ramda_1.compose(function (str) { return str.replace(/\W/g, '').toLowerCase(); }, ascii, trim);
//# sourceMappingURL=charts.js.map